import routerConst from '../consts/routerConst';

function getRouteByPath(path) {
  try {
    for (let route in routerConst) {
      if (
        routerConst.hasOwnProperty(route) &&
        routerConst[route].path === path
      ) {
        return routerConst[route];
      }
    }
    return null;
  } catch (e) {
    console.log(e);
  }
}

export const getHeaderProps = function(path) {
  const route = getRouteByPath(path);
  return route || {};
};
